(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('store-user', {
            parent: 'entity',
            url: '/store-user?page&sort&search',
            data: {
                authorities: ["ROLE_USER"],
                pageTitle: 'backApp.storeUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-user/store-users.html',
                    controller: 'StoreUserController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-user-detail', {
            parent: 'store-user',
            url: 'store-user/{id}',
            data: {
                authorities: ["ROLE_USER"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-user/store-user-detail.html',
                    controller: 'StoreUserDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StoreUser', function(StoreUser) {
                            return StoreUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('store-user-detail.edit', {
            parent: 'store-user-detail',
            url: '/detail/edit',
            data: {
                authorities: ["ROLE_USER"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-user/store-user-dialog.html',
                    controller: 'StoreUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StoreUser', function(StoreUser) {
                            return StoreUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('store-user.new', {
            parent: 'store-user',
            url: '/new',
            data: {
                authorities: ["ROLE_USER"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-user/store-user-dialog.html',
                    controller: 'StoreUserDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        uuid: null,
                        password: null,
                        cancelled: null,
                        scope: null,
                        activated: true,
                        langKey: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-user.edit', {
            parent: 'store-user',
            url: '/{id}/edit',
            data: {
                authorities: ["ROLE_USER"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-user/store-user-dialog.html',
                    controller: 'StoreUserDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['StoreUser','$stateParams', function(StoreUser,$stateParams) {
                    return StoreUser.get({id : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-user.delete', {
            parent: 'store-user',
            url: '/{id}/delete',
            data: {
                authorities: ["ROLE_USER"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-user/store-user-delete-dialog.html',
                    controller: 'StoreUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StoreUser', function(StoreUser) {
                            return StoreUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('store-user', null, { reload: 'store-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
